export default function () {
  return {
    /**
     * Applicable Brand options from the facet endpoint, already run through
     * `prepareBrands()` so a thousand-Brand payload is normalized once per
     * fetch rather than once per keystroke.
     */
    options: [],

    /**
     * Hydration-only rows: selections the endpoint could not place in
     * `options`, each carrying `status: "no_matches" | "unavailable"`.
     */
    selected: [],

    loading: false,
    loadedOnce: false,
    error: false,

    /**
     * Monotonic request sequence. The response carries no request echo, so
     * this is what lets a slow response for an old filter context be dropped
     * instead of overwriting a newer one.
     */
    sequence: 0,

    /**
     * Monotonic retry signal, bumped by the facet's retry control (#30).
     *
     * The request itself stays with the grid — only the grid knows the buyer's
     * whole filter context and holds the API client — but the drawer the facet
     * lives in is mounted app-wide and is not the grid's descendant, so there
     * is no prop or emit between them. The grid watches this.
     */
    retryToken: 0,
  };
}
